import React from "react";

/**
 * Catches render/runtime errors in any admin page so a single page fault
 * shows a readable message + reload instead of blanking the whole app.
 */
class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Page crashed:", error, info);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.routeKey !== this.props.routeKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div
          style={{
            margin: "24px",
            padding: "24px 26px",
            borderRadius: "14px",
            border: "1px solid var(--color-border, #E9EDF3)",
            background: "var(--color-surface, #fff)",
            color: "var(--color-text-primary, #0C1424)",
            boxShadow: "0 1px 3px rgba(16,24,40,.06)",
            fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
          }}
        >
          <h2 style={{ margin: "0 0 6px", fontSize: 18, fontWeight: 800 }}>
            Something went wrong on this page
          </h2>
          <p style={{ margin: "0 0 14px", fontSize: 13.5, color: "var(--color-text-secondary, #5B6B82)" }}>
            The rest of the app is fine — reload to try again. Error detail:
          </p>
          <pre
            style={{
              margin: "0 0 16px",
              padding: "12px 14px",
              borderRadius: "10px",
              background: "var(--color-surface-2, #F8FAFC)",
              border: "1px solid var(--color-border-soft, #EFF2F7)",
              color: "var(--color-danger-text, #BE123C)",
              fontSize: 12.5,
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              fontFamily: "'JetBrains Mono', monospace",
            }}
          >
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              height: 38,
              padding: "0 16px",
              borderRadius: 10,
              border: 0,
              cursor: "pointer",
              fontWeight: 700,
              fontSize: 12.5,
              color: "#fff",
              background: "var(--color-primary, #4F46E5)",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default RouteErrorBoundary;
